import { render, staticRenderFns } from "./Nakes.vue?vue&type=template&id=005f0c86"
import script from "./Nakes.vue?vue&type=script&lang=js"
export * from "./Nakes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports